import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import { stageAssertionFromLocation } from './auth/callbackAssertion'
import './styles/global.css'
import './styles/coding.css'
import './styles/simulation-program.css'

// Remove the one-time WordPress assertion before React, analytics, or error
// reporting code can observe the callback URL. The value remains in memory only.
stageAssertionFromLocation()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
